import React, {useRef, useEffect, useState} from 'react'

const NewsCardBody = ({description}) => {
    const outerRef = useRef();
    const innerRef = useRef();
    const [willOverflow, setWillOverflow] = useState(false);
    const [overflowButton, setOverflowButton] = useState('')
    const [showExpand, setShowExpand] = useState(true)

    useEffect( () => {
        const inner = innerRef.current;
        if ( inner.clientHeight >= 145 ) {
            setWillOverflow(true)
        } else {
            setWillOverflow(false)
        }
    }, [description])

    useEffect(() => {
        if ( willOverflow ) {
            if ( showExpand ) {
                outerRef.current.classList.add('news-item-card-content-height')
                setOverflowButton(<div className="w-100 text-md-end mb-2 z-1"><button type="button" onClick={() => setShowExpand(false)} className="btn btn-link overflow-button">more</button></div>)
            } else {
                outerRef.current.classList.remove('news-item-card-content-height')
                setOverflowButton(<div className="w-100 text-md-end mb-2 z-1"><button type="button" onClick={() => setShowExpand(true)} className="btn btn-link overflow-button">less</button></div>)
            }
        } else {
            setOverflowButton('')
        }
    }, [willOverflow, showExpand, description])

    return (
        <>
            <div ref={outerRef} className="news-item-card-content overflow-hidden">
                <div ref={innerRef} dangerouslySetInnerHTML={{__html: description}}/>
            </div>
            {overflowButton}
        </>
    )
}

export default NewsCardBody
